// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PaperAbstract-cls1___de27082794734e7e778{/*!*/}.PaperAbstract-cls2___55c5357f264acf20dab{}.PaperAbstract-cls2___55c5357f264acf20dab:hover,.PaperAbstract-cls2___55c5357f264acf20dab:active,.PaperAbstract-cls2___55c5357f264acf20dab:focus{color:inherit}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "PaperAbstract-cls1___de27082794734e7e778",
	"cls2": "PaperAbstract-cls2___55c5357f264acf20dab PaperAbstract-cls1___de27082794734e7e778"
};
export default ___CSS_LOADER_EXPORT___;
